export default __webpack_public_path__ + "c06f48af4752805d2bfa66b34fbd7d75.png";